import React, {Component} from "react";
import {Link} from "react-router";
import Table from "../../components/Table";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {getCountryFromCode} from "../../lib/CountriesAndStates";
import {fromJS, List, Map, Set} from "immutable";
import {graphql} from "react-apollo";
import gql from "graphql-tag";
import "./ProductDistributionOverview.css";

class ProductDistributionOverview extends Component {

  render() {
    let {loading, error, shippingProductDistribution} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let data = fromJS(shippingProductDistribution);
    // Get unique countries
    let countryData = data.reduce((acc, item) => {
      return acc.add(item.get("countryCode"));
    }, Set([]))
    .sort()
    .map(countryCode => {
      return Map({
        countryCode: countryCode,
        countryName: getCountryFromCode(countryCode).get("name"),
        year: this.props.year
      })
    });

    let tableHeader = List([
      "Country"
    ])         

    return (      
      <Table 
        data={countryData} 
        renderer={CountryItem} 
        tableHeader={tableHeader}
        itemKey="countryCode"
        mode="table"
        />
    )
  }

}

const CountryItem = ({data}) => {
  return (
    <tr className="item product-distribution-country-item">
      <td className="field u-nowrap"><Link to={`/shipping/product-distribution/${data.get("countryCode")}/${data.get("year")}`}>{data.get("countryName")}</Link></td>
    </tr>
  )
}

const QUERY = gql`
  query productDistribution($year:Int!) {
    shippingProductDistribution(year: $year) {
      countryCode
      countryName
      year
    }
  }
`


const withQuery = graphql(QUERY, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      year: props.year
    }
  })
})

export default withQuery(ProductDistributionOverview);
